<template>
	<div class="conditions" :class="{ 'sub-conditions': subConditions, 'bulleted': bullet }">
		<div v-for="(condition, i) in conditionList.conditions" :key="condition.id" class="d-flex conditions-list">
			<span class="d-flex flex-grow-1">
				<!-- <bullet v-if="bullet" :style="{ visibility:  i == 0 ? 'visible' : 'hidden' }" padding-right="10" /> -->
				<span v-if="!subConditions && (isFirst || i == 0)" class="operator" style="min-width: 30px; color: #fff">{{$t('condition-list.if')}}</span>
				<span v-else-if="i > 0" class="operator" :style="{ 'min-width': subConditions ? '' : '30px' }">{{conditionOperator.toLowerCase() | conditionOperator}}</span>
				
				<condition-list
					v-if="!condition.subconditions.empty" 
					:sub-conditions="true"
					:condition-list="condition.subconditions"
					:condition-operator="condition.conditionOperator"
					:is-first="i == 0"
				/>
				<template v-else>
					<span class="flex-grow-1">
						<condition
							:condition-object="condition"
							:operator="conditionOperator"
							@remove="onRemoveCondition(condition)"
						/>
					</span>
				</template>
				
			<!-- <div class="validity">
				<div v-if="validCondition" class="valid-result"></div>
				<div v-else class="invalid-result"></div>
				<div v-if="validityCheckError">Couldnt Check</div>
			</div> -->

			</span>
			<span v-if="(!subConditions) || (!condition.subconditions.empty)" class="actions">
				<div 
					left 
					v-if="!$store.state.showingTemplateBackupInPreview" 
					class="condition-action"
					@click="handleAction($event, 'default', () => { onCloneToOr(condition) })"
					:tooltip="$store.state.showTooltips == true ? $t('condition-list.clone-latest') : ''  "
					tooltip-placement="left"
				>
					<i class="fa-light fa-clone" ></i>
				</div>
				<dropdown 
					left 
					v-if="!$store.state.showingTemplateBackupInPreview" 
					class="condition-action"
					:tooltip="$store.state.showTooltips == true ? $t('condition-list.add-condition')  : ''  "
					tooltip-placement="left"
					:disabled="isDemo"
				>
					<div @click="handleAction($event, 'createNew')" slot="toggle" style="cursor: pointer">
						<i class="fa-light fa-plus" ></i>
					</div>
					<div class="dropdown-item" @click="onAddSubCondition(condition)">{{$t('condition-list.or')}}</div>
					<div class="dropdown-item" @click="onAddCondition(i)">{{$t('condition-list.and')}}</div>
				</dropdown>

				<div 
					class="condition-action"
					@click="handleAction($event, 'deleteCondition', () => { onRemoveCondition(condition) })"
					:tooltip="$store.state.showTooltips == true ? $t('condition-list.delete-condition')  : ''  "
					tooltip-placement="left"
				>
					<i class="fa-light fa-trash"></i>
				</div>


			</span>
		</div>
		<div class="no-conditions d-flex" v-if="conditionList.empty && !$store.state.showingTemplateBackupInPreview">
			<!-- <bullet v-if="bullet" padding-right="10" /> -->
				<span class="text-muted" style="margin-right: 3px;">{{$t('condition-list.condition-desc')}} </span>
			<a @click.stop.prevent="handleAction($event, 'createNew', () => { conditionList.addNewCondition(-1) }) " style="padding-right: 12px;"> {{$t('sentence.add')}}</a>
			<!-- <i class="flex-grow-1">{{$t('condition-list.no-condition')}}</i>
			<div class="actions">
				<a @click.stop.prevent="conditionList.addNewCondition(-1)" style="padding-right: 12px;">{{$t('condition-list.condition')}}</a>
			</div> -->
		</div>
	</div>
</template>

<script>
import Condition from '@/components/Condition'
import EventBus from '@/assets/js/eventBus.js'
import Dropdown from '@/components/Dropdown'
import {editorMixin}  from "@/assets/js/editorMixin.js"
export default {
	name: "conditions",
	mixins: [editorMixin],
	props: {
		conditionList: {
			type: Object,
			required: true
		},
		conditionOperator: {
			type: String,
			required: true
		},
		subConditions: {
			type: Boolean
		},
		isFirst: {
			type: Boolean
		},
		bullet: {
			type: Boolean
		},
		placeholder: {
			type: String
		}
	},
	data () {
		return {		
	
		}
	},
	computed: {
		isDemo(){
			return this.$store.state.editorIsDemoVersion
		}
	},
	methods: {
		onCloneToOr(condition){
			condition.cloneAsSubCondition()
		},
		onAddCondition(index) {
			this.conditionList.addNewCondition(index)
			EventBus.$emit('templateChange')
		},
		onAddSubCondition (condition) {
			condition.addSubcondition()
			EventBus.$emit('templateChange')
		},
		onRemoveCondition(condition) {
			this.conditionList.remove(condition)
			if (this.conditionList.empty) this.$emit('remove')
			EventBus.$emit('templateChange')
			// // emit this change to parent sentences, to make sure that we clean up upwards
			// this.$emit('change')
		},
	},
	created(){
	
	},
	components: {
		Condition,
		Dropdown
	}
}
</script>

<style lang="less">
	.conditions {
		background: rgba(176, 179, 176, 0.144);
		margin-left: 10px;
		border-radius: 13px 0 0 13px;
		&.sub-conditions {
			display: flex;
			flex-wrap: wrap;
		}

		.condition {
			margin-right: 10px;
		}
	
		.actions {
			display: flex;
			justify-content: center;
			white-space: nowrap;
			visibility: hidden;
			padding: 0 15px;
			.condition-action {
				margin-right: 12px;
			}
		}

		&:not(.sub-conditions) {
			> .conditions-list {
				padding-left: 8px;
				&:hover {
					background-color: #6E757A;
					border-radius: 13px 0 0 13px;
				}
					.actions {
						visibility: visible;
					}
				}
			}
		.no-conditions {
			padding-left: 8px;
		}

		.operator {			
			margin-right: 10px;
		}
	}
</style>


